import { PROFILE_STATUS } from 'global.enums';
import { IOnboardingConfiguration, IUser } from 'global.interfaces';

export enum ROUTE_CATEGORY {
  SOCIAL_TRADING,
  TRAIDING_TOOLS,
  BONUSES,
  FAQ,
  EDUCATION_PORTAL,
  TRADING_CONTESTS,
  LOYALTY_PROGRAMS,
  PARTNERSHIP,
}

export const isOnboardingRestricted = (
  onboardingConfiguration: IOnboardingConfiguration,
  userInfo: IUser,
  routeCategory?: ROUTE_CATEGORY,
): boolean => {
  const userStatus = userInfo?.profile?.status;
  const canAddToTree = userInfo?.canAddToTree;
  const {
    showCopyTradingTab,
    showTradingToolTab,
    showBonusesTab,
    showFaqTab,
    showEducationPortalTab,
    showTradingContestsTab,
    showLoyaltyProgramsTab,
  } = onboardingConfiguration;

  switch (true) {
    case routeCategory === ROUTE_CATEGORY.SOCIAL_TRADING:
      return !showCopyTradingTab;
    case routeCategory === ROUTE_CATEGORY.TRAIDING_TOOLS:
      return !showTradingToolTab;
    case routeCategory === ROUTE_CATEGORY.BONUSES:
      return !showBonusesTab;
    case routeCategory === ROUTE_CATEGORY.FAQ:
      return !showFaqTab;
    case routeCategory === ROUTE_CATEGORY.EDUCATION_PORTAL:
      return !showEducationPortalTab;
    case routeCategory === ROUTE_CATEGORY.TRADING_CONTESTS:
      return !showTradingContestsTab;
    case routeCategory === ROUTE_CATEGORY.LOYALTY_PROGRAMS:
      return !showLoyaltyProgramsTab;
    case routeCategory === ROUTE_CATEGORY.PARTNERSHIP:
      return !canAddToTree;
    default:
      return userStatus === PROFILE_STATUS.URGENTUPDATE;
  }
};
